import { Notification, NOTIFICATION_STATUS } from '~/models/Notification'
import { Page } from '~/models/PaginatedItems'
import { BaseRepository } from '../baseRepository'
import { ApiPage, toPage } from '../shared/pagination'
import { ApiNotification } from './apiTypes'
import { NotificationEntityMapper } from './entityMapper'
import { NotificationApiMapper } from './apiMapper'

export class NotificationRepository extends BaseRepository {
	static resource = 'v1/notifications'

	static async getUserNotifications(
		userId: string,
		page: number = 0,
		pageSize: number = 10
	): Promise<Page<Notification>> {
		const params = {
			user_id: userId,
			page,
			page_size: pageSize,
		}
		const response: ApiPage<ApiNotification> = await this.get(`${this.resource}/`, params)

		const results = NotificationEntityMapper.toNotifications(response.results)
		return toPage(response, results)
	}

	static async countBy(userId: string, status?: NOTIFICATION_STATUS): Promise<number> {
		const params: Record<string, string | NOTIFICATION_STATUS> = { user_id: userId }
		if (status) params.status = NotificationApiMapper.toNotificationStatus(status)
		const response: { count: number } = await this.get(`${this.resource}/count/`, params)

		return response.count
	}

	static async markAsRead(notificationId: string): Promise<Notification> {
		const response: ApiNotification | undefined = await this.post(
			`${this.resource}/${notificationId}/read/`
		)
		return NotificationEntityMapper.toNotification(response!)
	}

	static async markAllAsRead(): Promise<void> {
		await this.post(`${this.resource}/read_all/`)
	}
}
